/**
 * Is this string worth trying to send mail to?
 *
 * ONE implementation, used by every surface that offers to email
 * somebody, because the three that existed before did not agree:
 * "Create user" and the reset dialog each tested `includes("@")`, which
 * accepts `"@"`, `"a@"` and `"@b"` — so the control that was supposed to
 * be gated on a usable address unlocked on a single keystroke.
 *
 * DELIBERATELY NOT RFC 5322. A complete grammar for an address is a
 * famously enormous regex, and every line of it buys precision this
 * screen cannot use: the only question here is whether pressing Send has
 * any chance of working, and the real verdict comes from the mail
 * provider afterwards. What this must catch is the honest mistakes —
 * empty, no `@`, nothing before or after it, no dot in the domain, a
 * stray space from a paste.
 *
 * It is deliberately permissive about the local part (`+` tags, dots and
 * apostrophes are all real) and strict about the shape.
 */
const SHAPE = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

export function isValidEmail(value: string | null | undefined): boolean {
  const trimmed = (value ?? "").trim();
  // An address longer than this cannot be delivered anyway (RFC 5321
  // caps the path at 256 including the angle brackets), and the guard
  // keeps a pasted document out of the field.
  if (trimmed.length === 0 || trimmed.length > 254) return false;
  return SHAPE.test(trimmed);
}
